import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchDasSubscriptionsData, selector as dasSubscriptionsApi } from './listDasSlice';
import { Status } from '../../../../common/constants';
import { useSpinner } from '../../../../customHooks';
import { IDasSubscriptionsApi, IDasSubscription } from '../../../../common/types/dasTypes';
import { actions as spinnerActions } from '../../../../components/ui/spinner/spinnerSlice';

const useListDas = () => {
    const dispatch: any = useDispatch();
    const dasSubscriptions: IDasSubscriptionsApi = useSelector(dasSubscriptionsApi);

    const [dasSubscriptionsData, setDasSubscriptionsData] = useState<IDasSubscription[]>([]);
    useSpinner();
    useEffect(() => {
        dispatch(spinnerActions.setApiStatus(dasSubscriptions.status));
    }, [dasSubscriptions.status])

    useEffect(() => {
        if (dasSubscriptions.dasSubscriptions && dasSubscriptions.dasSubscriptions.values !== dasSubscriptionsData) {
            setDasSubscriptionsData(dasSubscriptions.dasSubscriptions.values);
        }
    }, [dasSubscriptions.dasSubscriptions])    


    if (dasSubscriptions.status == Status.IDLE) {
        dispatch(fetchDasSubscriptionsData())
    }

    const [activeAccordion, setActiveAccordion] = useState<number | null>(null);

    const toggleAccordion = (index: number) => {
      setActiveAccordion(activeAccordion === index ? null : index);
    };

    return {
        dasSubscriptionsData,
        activeAccordion,
        toggleAccordion
    }

};

export default useListDas;
